import { requester } from '../utils';

export const fetchReservationInvoiceDetails = id => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/invoice/reserve/${id}`,
        method: 'GET',
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch users error', err);
        reject(err);
      });
  });
};

export const fetchReservationTemporaryPrint = (id, printMode = 'PRINT') => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/invoice/temporary-print/${id}/${printMode}`,
        method: 'GET',
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch users error', err);
        reject(err);
      });
  });
};

export const fetchReservationTemporaryPrintByPrinterTarget = (
  reserveId,
  printerTarget,
  printMode = 'PRINT',
) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/invoice/temporary-print/${reserveId}/${printerTarget}/${printMode}`,
        method: 'GET',
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch users error', err);
        reject(err);
      });
  });
};

export const fetchReservationFactorPrint = id => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/invoice/sale-invoice-print/${id}`,
        method: 'GET',
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch users error', err);
        reject(err);
      });
  });
};

export const fetchAllCafeReservations = query => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/reserve/archive?${query}`,
        method: 'GET',
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch users error', err);
        reject(err);
      });
  });
};

export const fetchAllReservationRequests = query => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/reserve/requests?${query}`,
        method: 'GET',
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch users error', err);
        reject(err);
      });
  });
};

export const fetchAllIncomingReservations = query => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/reserve/ahead?${query}`,
        method: 'GET',
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch users error', err);
        reject(err);
      });
  });
};

export const fetchAllReservationDays = query => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe-date?${query}`,
        method: 'GET',
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch users error', err);
        reject(err);
      });
  });
};

export const fetchReservationDayDetails = id => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe-date/${id}`,
        method: 'GET',
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch users error', err);
        reject(err);
      });
  });
};

export const fetchReservationHourDetails = id => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe-time-slice/${id}`,
        method: 'GET',
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch users error', err);
        reject(err);
      });
  });
};

export const changeReservationDayStatus = (id, status) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe-date/status`,
        method: 'PUT',
        data: {
          id,
          status,
        },
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch users error', err);
        reject(err);
      });
  });
};

export const fetchAllTableNumbers = () => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/table/cafe`,
        method: 'GET',
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.error('fetchAllTableNumbers error', err);
        reject(err);
      });
  });
};

export const fetchAllReservationHours = (query, cafeDateId) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe-time-slice/cafe-date/${cafeDateId}?${query}`,
        method: 'GET',
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch users error', err);
        reject(err);
      });
  });
};

export const insertNewReservationDay = ({
  reserveTypes,
  status,
  meals,
  date,
}) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe-date`,
        method: 'POST',
        data: {
          reserveTypes,
          status,
          meals,
          date,
        },
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch users error', err);
        reject(err);
      });
  });
};

export const updateReservationDay = reservationObject => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe-date`,
        method: 'PUT',
        data: reservationObject,
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch users error', err);
        reject(err);
      });
  });
};

export const startReservation = id => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/reserve/start`,
        method: 'PUT',
        data: { id },
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch users error', err);
        reject(err);
      });
  });
};

export const insertNewReservationHour = ({
  cafeDateId,
  cafeTableId,
  fromTime,
  toTime,
  status,
}) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe-time-slice`,
        method: 'POST',
        data: {
          cafeDateId,
          cafeTableId,
          fromTime,
          toTime,
          status,
        },
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch users error', err);
        reject(err);
      });
  });
};

export const updateReservationHour = ({
  id,
  cafeTableId,
  fromTime,
  toTime,
  status,
}) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe-time-slice`,
        method: 'PUT',
        data: {
          id,
          cafeTableId,
          fromTime,
          toTime,
          status,
        },
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch users error', err);
        reject(err);
      });
  });
};

export const updateReservationHourStatusAtSchematics = data => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe-time-slice`,
        method: 'PUT',
        data,
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('update reservation status at schematics error', err);
        reject(err);
      });
  });
};

export const deleteReservationDay = id => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe-date/${id}`,
        method: 'DELETE',
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch users error', err);
        reject(err);
      });
  });
};

export const deleteReservationHour = id => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/cafe-time-slice/${id}`,
        method: 'DELETE',
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch users error', err);
        reject(err);
      });
  });
};

export const fetchReservationDetails = id => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/reserve/${id}`,
        method: 'GET',
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch users error', err);
        reject(err);
      });
  });
};

export const editReserveStatus = (params, status) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route:
          status == 'APPROVED'
            ? `v1/reserve/approve`
            : status === 'CLIENT_DO_NOT_CAME'
            ? 'v1/reserve/client-do-not-came'
            : 'v1/reserve/reject',
        method: 'PUT',
        data: {
          ...params,
        },
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch users error', err);
        reject(err);
      });
  });
};

export const clientReason = ({ id, clientReason, otherClientReasons }) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: 'v1/reserve/client-do-not-came',
        method: 'PUT',
        data: {
          id,
          clientReason,
          otherClientReasons,
        },
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch users error', err);
        reject(err);
      });
  });
};

export const temproraySaveInvoice = (id, invoiceItems) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: 'v1/invoice/temporary',
        method: 'PUT',
        data: {
          id,
          invoiceItems,
        },
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch users error', err);
        reject(err);
      });
  });
};

export const finalSaveInvoice = (id, invoiceItems) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: 'v1/invoice/final',
        method: 'PUT',
        data: {
          id,
          invoiceItems,
        },
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch users error', err);
        reject(err);
      });
  });
};

export const fetchAllUserReservationsById = (userId, query) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/reserve/user/${userId}?${query}`,
        method: 'GET',
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const fetchAllCheckedoutOrClientAbsentReserves = query => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/checkout-with-cafe?${query}`,
        method: 'GET',
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const fetchAllClientAbsentOrNotFinishedReserve = query => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/reserve/ready-to-checkout?${query}`,
        method: 'GET',
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const checkoutCafeReserves = item => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/checkout-with-cafe`,
        method: 'POST',
        data: item,
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const fetchCheckoutReserveDetails = id => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/checkout-with-cafe/${id}`,
        method: 'GET',
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const finalCheckoutCafeReserves = item => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/checkout-with-cafe/final`,
        method: 'POST',
        data: item,
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const fetchIncominSchematicReservation = reserveDate => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/reserve/schematic/${reserveDate}`,
        method: 'GET',
        withAuth: true,
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};
